import { useState } from "react";
import useDeleteAccount from "../../../../../../../../hooks/useDeleteAccount";
import Button from "../../../../../../../../library/button";
import { Text } from "../../../../../../../../library/text";
import { getIcon } from "../../../../../../../../utils/get-icon";
import { ButtonsWrapper, TextWrapper } from "./styled";

interface Props {
  onSuccess: () => void;
  onError: () => void;
}

const DeleteModal = ({ onSuccess, onError }: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { deleteAccount } = useDeleteAccount();

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const deletion = await deleteAccount();
      if (deletion.error === null) {
        onSuccess();
      } else {
        throw new Error("Failed");
      }
    } catch (e) {
      onError();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <TextWrapper>
        <Text size="small" color="dark">
          Vær klar over at alle arbeidsområder hvor du er eneste medlem, slettes
          umiddelbart med alt innhold. Delt innhold i andre arbeidsområder blir
          gjort anonymt, mens dine private filer alltid slettes.
        </Text>
      </TextWrapper>
      <ButtonsWrapper>
        <Button
          onClick={handleDelete}
          disabled={false}
          type="submit"
          color="red"
          variant="regular"
        >
          {isLoading ? (
            <>{getIcon("spinner")} Sletter..</>
          ) : (
            <>Slett konto og innhold</>
          )}
        </Button>
      </ButtonsWrapper>
    </>
  );
};

export default DeleteModal;
